import {Stack} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'
import Label from '../../customTable/Label'

export default function TableHead({isFull}: any) {
  const {t} = useTranslation()

  const headTable = [
    {
      name: t('product'),
      class: 'min-w-200px',
      width: '340px',
      details: '1',
    },
    {
      name: t('model'),
      class: 'min-w-200px',
      width: '120px',
      details: '1',
    },
    {
      name: t('qty'),
      class: 'min-w-180px',
      width: '120px',
      details: '1',
    },
    {
      name: t('uitPrice'),
      class: 'min-w-180px',
      details: '1',

      width: '120px',
    },
    {
      name: t('subTotal'),
      details: 'beforeDiscount',
      class: 'min-w-180px',
      width: '120px',
    },
    {
      name: t('total'),
      details: 'afterDiscount',

      class: 'min-w-180px',
      width: '120px',
    },
  ]

  return (
    <thead>
      <tr
        // style={{display:'flex',justifyContent:'space-between'}}
        className='fw-bold text-muted'
      >
        {headTable.map((e, i) => (
          <th
            style={{
              textAlign: i === 0 ? 'start' : 'start',
              width: i === headTable.length - 1 ? '40px' : 'auto',
              minWidth: i === headTable.length - 1 ? '120px' : e.width,
            }}
            key={i}
            // className={e.class}
          >
            <Stack>
              <p className='text-web pl-20 min-w-150px fs-18-med'>{e.name}</p>
              <Label
                color={e.details == '1' ? '#00000000' : '#abafbf'}
                fs='11px'
                text={e.details}
              />
            </Stack>
          </th>
        ))}
      </tr>
    </thead>
  )
}
